import { render, staticRenderFns } from "./mailing-list.vue?vue&type=template&id=333d3b78&"
import script from "./mailing-list.vue?vue&type=script&lang=js&"
export * from "./mailing-list.vue?vue&type=script&lang=js&"
import style0 from "./mailing-list.vue?vue&type=style&index=0&id=333d3b78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports